import { Box, Center } from '@chakra-ui/react';
import { take } from 'lodash';
import ShortSelfIpoGrid from 'presentation/components/modules/selfIpo/ShortSelfIpoGrid';
import { isSelfIpoVisibleOnHome } from 'presentation/components/modules/selfIpo/selfIpoUtils';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { useFetchSelfIpoOfferingsQuery } from 'rtkQuery/sharespro/queries/selfIpo';

const HomeSelfIpoContainer: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, error, refetch } = useFetchSelfIpoOfferingsQuery();
  const visibleOfferings = data?.filter(isSelfIpoVisibleOnHome) ?? [];

  let content;
  if (visibleOfferings.length > 0) {
    content = (
      <ShortSelfIpoGrid
        offerings={take(visibleOfferings, 3)}
        onCardClick={(id) => navigate(AppRoute.selfIpoDetail(id))}
      />
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  if (!content) {
    return null;
  }

  return (
    <Box mb="20px">
      <GridHeading
        trailingLink={{
          text: t('allItems'),
          path: AppRoute.selfIpo,
        }}
      >
        {t('selfIpoTitle')}
      </GridHeading>
      {visibleOfferings.length > 0 ? (
        content
      ) : (
        <AppCard p="20px">
          <Center>{content}</Center>
        </AppCard>
      )}
    </Box>
  );
};

export default HomeSelfIpoContainer;
